import StyledLink from '../StyledLink'
import {
  SYSTEM,
  WEBHOOK
} from '../routes'
import type { Props } from '../types'

interface Params {
  uuid: string
}

const LinkToEditWebhookConfig = ({
  children,
  uuid,
  isHyperlink
}: (Props & Params)) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${SYSTEM}/${WEBHOOK}/${uuid}/edit`}
  >
    {children}
  </StyledLink>

export default LinkToEditWebhookConfig
